// Source: https://stackoverflow.com/questions/49682569/typescript-merge-object-types
// jcalz 2021-09-09
export function mergeObjects(...a) {
    return Object.assign({}, ...a);
}
